class WImenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        let mMenu = document.querySelector('.WI_mobileMenu_main'); 
        let mMenuIn = document.querySelector('.WI_mobileMenu_in');
        let mMeniLi = document.querySelectorAll('.WI_menulinkMobile');
        let mMenuClose = document.querySelector('.WI_mobileMenu_close');
        // Open menu
        this.addEventListener('click', ()=>{
           mMenu.style.display = "block";
           setTimeout(() => {
               mMenuIn?.classList.add('WI_mobileMenu_in_open');
               setTimeout(() => {
                   mMeniLi.forEach(m => {
                    m.style.display = "block";
                   });
               },300);
            });
        });    
        // Clsoe menu
        mMenuClose?.addEventListener('click', ()=>{
            mMenuIn?.classList.remove('WI_mobileMenu_in_open');
            setTimeout(() => {
                mMenu.style.display = "none";
                mMeniLi.forEach(m => {
                    m.style.display = "none";
                   });
            }, 500);
        });
    }


}

customElements.define("wi-menu-opner", WImenu);